import React, { useEffect, useRef, useState } from 'react';
import './QuickActions.scss';
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ClientPortal from './user-portal/clientPortalModal';
import {
	QAContactIcon,
	QACreditNoteIcon,
	QAEstimateIcon,
	QAInvoiceIcon,
} from 'ui-component/custom-icons/icons';

import { BsPersonFillAdd } from "react-icons/bs";

import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { useHotkeys } from 'react-hotkeys-hook';

import { FiPlus } from 'react-icons/fi';

// ✅ Clear
function QuickActions({
    showActions,
    setShowActions,
    searchExpand,
    setSearchExpand
}) {
    const [newShow, setNewShow] = useState(false);

    const compRef = useRef(null);
    const buttonRef = useRef(null);

    const actionRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

    // Provide default values if not passed
    const [internalShowActions, setInternalShowActions] = useState(false);
    const [internalSearchExpand, setInternalSearchExpand] = useState(false);

    const actionsVisible = typeof showActions === 'boolean' ? showActions : internalShowActions;
    const setActionsVisible = setShowActions || setInternalShowActions;
    const searchVisible = typeof searchExpand === 'boolean' ? searchExpand : internalSearchExpand;
    const setSearchVisible = setSearchExpand || setInternalSearchExpand;

    useHotkeys('c', () => {
        setActionsVisible(!actionsVisible);
        setSearchVisible(false);
    });

    useHotkeys(['1', '2', '3', '4', '5', '6', '7', '8'], (e) => {
        if (actionsVisible) {
            actionRefs?.[e?.key - 1]?.current?.click();
        }
    });
    const handleNewClose = () => {
        setNewShow(false);
    };


    const handleClickOutside = (event) => {
        if (compRef.current && !compRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
            setActionsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const toggleShowActions = () => {
        if (!actionsVisible) setSearchVisible(false);
        setActionsVisible((prev) => !prev);
    };
    useEffect(() => {
        // If search is being opened, close actions
        if (searchVisible && actionsVisible) {
            setActionsVisible(false);
        }
        // If actions are being opened, close search
        if (actionsVisible && searchVisible) {
            setSearchVisible(false);
        }
        // Only runs when either is opened, not closed
    }, [searchVisible, actionsVisible]);


    const onAddNewClient = (data) => {
        toast.promise(
            api
                .createShipments({
                    transit_company_id: data?.ship_to,
                    shipping_company_id: data?.ship_with,
                    tracking_no: data?.tracking_number,
                    package_ids: data?.packages
                })
                .then((res) => {
                    setNewShow(false);

                    if (res?.status) {
                        handleFilter();
                    }
                    return res?.status ? res : null;
                }),
            {
                loading: 'Creating SShipment...',
                success: (data) => `${data.message}`,
                error: <b>Failed to create shipment</b>
            }
        );
    };
    const Openpopup = () => {
        setNewShow(true);
        setActionsVisible(false)
    }

    return (
        <div className="quick-actions-component">
            <button
                className="btn btn-main-primary btn-rounded d-none d-md-block"
                style={{ minWidth: '85px' }}
                onClick={toggleShowActions}
                ref={buttonRef}
            >
                <FaPlus /> Create
            </button>

            <span className="d-md-none btn-new-mobile btn-primary" onClick={toggleShowActions}>
                <FiPlus size={16} />
            </span>

            {actionsVisible ? (
                <div className={`quick-action-popover-container`}>
                    <div className="quick-action-popover" ref={compRef}>
                        <div className="quick-action-item-section">
                            <div className="link-list">
                                <PermissionAllowed permissions={['Create Estimation (Page)']}>
                                    <Link to={'/sales/estimates/create'} onClick={() => setActionsVisible(false)} className="link-list-item" ref={actionRefs[0]}>
                                        <span className="qa-icon" style={{ color: '#D8578A' }}>
                                            <QAEstimateIcon width="15" height="15" style={{ fill: '#D8578A' }} />
                                        </span>
                                        <p>Quotation</p>
                                    </Link>
                                </PermissionAllowed>

                                <PermissionAllowed permissions={['Create Estimation (Page)']}>
                                    <Link to={'/sales/invoices/create'} onClick={() => setActionsVisible(false)} className="link-list-item" ref={actionRefs[1]}>
                                        <span className="qa-icon" style={{ color: '#F39C12' }}>
                                            <QAInvoiceIcon width="15" height="15" style={{ fill: '#F39C12' }} />
                                        </span>
                                        <p>Invoice</p>
                                    </Link>
                                </PermissionAllowed>

                                <PermissionAllowed permissions={['Create Estimation (Page)']}>
                                    <Link
                                        to={'/sales/credit-note/create'}
                                        onClick={() => setActionsVisible(false)}
                                        className="link-list-item"
                                        ref={actionRefs[1]}
                                    >
                                        <span className="qa-icon" style={{ color: '#795AAA' }}>
                                            <QACreditNoteIcon width="15" height="15" style={{ fill: '#795AAA' }} />
                                        </span>
                                        <p>Credit Note</p>
                                    </Link>
                                </PermissionAllowed>

                                <PermissionAllowed permissions={['Create Contact (Page)']}>
                                    <Link to={'/contacts/create'} onClick={() => setActionsVisible(false)} className="link-list-item" ref={actionRefs[4]}>
                                        <span className="qa-icon" style={{ color: '#555CF3' }}>
                                            <QAContactIcon width="15" height="15" style={{ fill: '#555CF3 !important' }} />
                                        </span>
                                        <p>Contact</p>
                                    </Link>
                                </PermissionAllowed>
                                <a onClick={() => Openpopup()} className="link-list-item" style={{ cursor: 'pointer' }} ref={actionRefs[7]}>
                                    <span className="qa-icon">
                                        <BsPersonFillAdd style={{ fill: '#34C880' }} />
                                    </span>
                                    <p>Client Portal</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ''
            )}
            {newShow && <ClientPortal newShow={newShow} handleNewClose={handleNewClose} onSubmit={onAddNewClient} />}
        </div>
    );
}

export default QuickActions;
